import { useGetUser } from './use-get-user';
// My defining `options` outside, we have a stable reference to pass to `useUser`,
// avoiding having to `useCallback` the `select`.
const select = (data) => data.canListMyTimesheets;
/**
 * @returns Falls back to `true` if the user is not loaded yet to avoid blocking the UI.
 */
export const useCanListMyTimesheets = (options) => {
    return (useGetUser(undefined, {
        ...options,
        select,
    }).data ?? true);
};
//# sourceMappingURL=use-can-list-my-timesheets.js.map